import { toast } from 'react-toastify';
import { Socket } from 'socket.io-client';

import escConstants from '../constants';
import Store from '../store';

export const Subscribers = (socket: Socket) => {
  socket.on('notification', (newNotification: any) => {
    const notification = newNotification?.data;
    Store.store.dispatch(
      Store.Actions.update('notifications.data', {
        data: [notification],
        position: 'front',
      }),
    );
    const users = localStorage.getItem(escConstants.LOCAL_STORAGE_KEY.user);
    const parsedUsers = users ? JSON.parse(users) : {};

    if (notification?.notifyTo !== parsedUsers?._id)
      toast(notification.message, {
        position: 'top-center',
        type: 'info',
        hideProgressBar: true,
      });
  });

  socket.on('unreadNotifications', (unreadNotification: any) => {
    Store.store.dispatch(
      Store.Actions.set('notificationCount', {
        data: unreadNotification,
      }),
    );
  });
};
